import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import type { RootState } from '../reducers/reducers';

export interface BaseAPIResponse<T> {
    data: T;
    errorMessage?: string;
    success: boolean;
}

export const baseQuery = fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: (headers, { getState }) => {
        const state = getState() as RootState;
        const auth = state.auth?.authCredentials;
        if (auth?.token) {
            headers.set('authorization', `Bearer ${auth.token}`);
        }
        return headers;
    },
});
